import classNames from "classnames";
import React from "react";
import {
  NOT_SELECTED_LANGUAGE_COLOR,
  SELECTED_LANGUAGE_COLOR,
} from "./constants";

const GovGrLanguageSelector = ({
  userlanguages = [
    {
      languageDisplayName: "EL",
      languageLocaleName: "el-GR",
      onClick: () => {
        console.log("yes");
      },
    },
    {
      languageDisplayName: "EN",
      languageLocaleName: "en-US",
      onClick: () => {
        console.log("yes");
      },
    },
  ],
  selectedLanguage = "en-US",
}) => {
  const wrapperClassName = classNames("flex space-x-2 ml-4");
  return (
    <div className={wrapperClassName}>
      {userlanguages.map((item, index) => {
        const buttonClassName = classNames(
          "w-12 h-12 rounded-md text-1xl font-bold text-white",
          {
            [`bg-[#032568]`]: selectedLanguage === item.languageLocaleName,
          },
          {
            [`bg-[#383838]`]: selectedLanguage !== item.languageLocaleName,
          }
        );

        return (
          <button
            className={buttonClassName}
            onClick={item.onClick}
            key={index}
          >
            {item.languageDisplayName}
          </button>
        );
      })}
    </div>
  );
};

export default GovGrLanguageSelector;
